var exports = {
  "P_": "SanitizedHtml__9ksDLr",
  "q_": "ArchivedLabelContent__6FKmPt",
  "uh": "ArchivedLabelIcon__r1G4AT",
  "az": "Box__CmWtts",
};

module.exports = exports;
